module.exports = __webpack_public_path__ + "img/emoticon-nps-0-off.fa474cc8.svg";